import { Modal } from "@general-backoffice/core/index";
import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

interface AmbassadorInfoModalProps {
  isOpen: boolean;
  close: () => void;
}

const AmbassadorInfoModal = ({ isOpen, close }: AmbassadorInfoModalProps) => {
  const { t } = useTranslation("referrer", { keyPrefix: "partner.ambassadorInfoModal" });

  return (
    <Modal.Simple isOpen={isOpen} toggleOpen={close} size="lg" title={t("title")} closeText={t("closeText")}>
      <div className="mx--4">
        <Container fluid className="text-center">
          <Row className="flex-center flex-column py-5 text-default">
            <Col xs="auto" style={{ fontSize: "4rem" }}>
              <i className="fas fa-users"></i>
            </Col>
            <Col xs="auto" className="display-4">
              {t("section1.title")}
            </Col>
          </Row>
          <Row className="flex-center flex-column bg-light py-5">
            <Col xs="auto" className="display-4 mb-3">
              {t("section2.title")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7 mb-3">
              {t("section2.subtitle")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7">
              {t("section2.otherText")}
            </Col>
          </Row>
          <Row className="flex-column-center py-5" style={{ rowGap: "1rem" }}>
            <Col xs={12} className="display-4 mb-3">
              {t("section3.title")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7">
              {t("section3.text")}
            </Col>
          </Row>
          <Row className="py-5 bg-light flex-column-center" style={{ rowGap: "1rem" }}>
            <Col xs={12} className="display-4 mb-3">
              {t("section4.title")}
            </Col>
            {[1, 2, 3].map((key) => {
              return (
                <Col xs={11} key={key} className="mb-3 text-left bg-white p-4">
                  <strong>{t(`section4.step${key}.title`)}</strong>
                  <p className="m-0">{t(`section4.step${key}.text`)}</p>
                </Col>
              );
            })}
            <Col xs={12}>{t("section4.footer")}</Col>
          </Row>
          <Row className="flex-column-center py-5" style={{ rowGap: "1rem" }}>
            <Col xs={12} className="display-4 mb-3">
              {t("section5.title")}
            </Col>
            <Col xs={"auto"} className="h3 text-dark opacity-7">
              {t("section5.text")}
            </Col>
          </Row>
        </Container>
      </div>
    </Modal.Simple>
  );
};

export default AmbassadorInfoModal;
